export default {
  translation: {
    'Split Lines': 'Käsittele rivikohtaisesti',
    'Split the lines of the voucher.': 'Käsittele kuitin rivit erikseen',
    'Voucher Interpretation': 'Kuitin tulkinta',
    'Keyword Account Filter': 'Kontekstin kirjanpitotili',
    'Keyword Tag Filter': 'Kontekstin avainsana',
    'Your Contexts': 'Kontekstisi',
    'Your Flows': 'Päätöspuusi',
    Contexts: 'Kontekstit',
    Flows: 'Päätöspuut',
    Assistants: 'Assistentit',
    Home: 'Koti',
    Any: 'Mikä tahansa',
    None: 'Ei mikään',
    'Any keyword': 'Mikä tahansa avainsana',
    'Bookkeeping Account in Context': 'Käytä kontekstin kirjanpitotiliä',
    'Reference Context': 'Viitekonteksti',
    'Input Node': 'Alkupiste',
    'User Node': 'Kysymys ihmiselle',
    'Alert Node': 'Hälytys',
    Assistant: 'Tekoäly',
    'Programmable Node': 'Koodi',
    Rename: 'Nimeä uudelleen',
    'Edit Description': 'Muokkaa kuvailua',
    Properties: 'Ominaisuudet',
    Delete: 'Poista',
    Untitled: 'Otsikollinen',
    Cancel: 'Peruuta',
    'User Feedback': 'Palaute',
    Output: 'Tulos',
    'Output Node': 'Tulostin',
    Alert: 'Huomio',
    'Split Lines Start': 'Rivikohtainen käsittely',
    'Split Lines End': 'Tositekohtainen käsittely',
    Journal: 'Päiväkirja',
    'General Ledger': 'Pääkirja',
    Dimensions: 'Seurantakohteet',
    Date: 'Päivämäärä',
    Descriptions: 'Kuvaus',
    Instructions: 'Ohjeet',
    Amount: 'Summa',
    Account: 'Tili',
    Balance: 'Saldo',
    'Sort by date:': 'Järjestä päivämäärän mukaan:',
    'Oldest first': 'Vanhimmat ensin',
    'Newest first': 'Uusimmat ensin',
    'Filter by dimension': 'Suodata seurantakohteen mukaan',
    'View full size': 'Näytä koko kuva',
    'Download receipt': 'Lataa kuitti',
    'No receipts to download': 'Ei ladattavia kuitteja',
    'Download filtered receipts': 'Lataa suodatetut kuitit',
    'Download all receipts': 'Lataa kaikki kuitit',
    'Reset all filters': 'Nollaa kaikki suodattimet',
    Reset: 'Nollaa',
    'Grid View': 'Ruudukkonäkymä',
    'Table View': 'Taulukkonäkymä',
    Image: 'Kuva',
    Title: 'Otsikko',
    Category: 'Kategoria',
    Status: 'Tila',
    'All Categories': 'Kaikki kategoriat',
    Month: 'Kuukausi',
    Year: 'Vuosi',
    NEW: 'UUSI',
    IN_PROGRESS: 'KÄSITTELYSSÄ',
    PENDING: 'ODOTTAA',
    COMPLETED: 'VALMIS',
    ALL_STATUSES: 'Kaikki tilat',
    Activity: 'Tapahtumat',
    Files: 'Tiedostot',
    Tasks: 'AI-tehtävät',
    Settings: 'Asetukset',
    Dashboard: 'Kojelauta',
    'Sign out': 'Kirjaudu ulos',
    'Page Not Found': 'Sivua ei löydy',
    "The page you're looking for doesn't exist.": 'Etsimääsi sivua ei löydy.',
    'Personal account for': 'Henkilökohtainen tili käyttäjälle',
    'New organisation name': 'Uuden organisaation nimi',
    'Unnamed organisation': 'Nimetön organisaatio',
    'Provide Feedback': 'Anna palautetta',
    Submit: 'Lähetä',
    Topic: 'Aihe',
    Feedback: 'Palaute',
    Rating: 'Arvosana',
    English: 'Englanti',
    Suomi: 'Suomi',
    Svenska: 'Ruotsi',
    Dansk: 'Tanska',
    Floness: 'Floness',
    'Customer:': 'Asiakas:',
    'Customer ID:': 'Asiakas ID:',
    'Created:': 'Luotu:',
    'Due:': 'Eräpäivä:',
    'Type:': 'Tyyppi:',
    'Show active tasks only': 'Näytä vain aktiiviset tehtävät',
    Expenses: 'Kulut',
    Sales: 'Myynti',
    'Bank Statements': 'Tiliotteet',
    'Documents Category': 'Dokumentit',
    Other: 'Muut',
    January: 'Tammikuu',
    February: 'Helmikuu',
    March: 'Maaliskuu',
    April: 'Huhtikuu',
    May: 'Toukokuu',
    June: 'Kesäkuu',
    July: 'Heinäkuu',
    August: 'Elokuu',
    September: 'Syyskuu',
    October: 'Lokakuu',
    November: 'Marraskuu',
    December: 'Joulukuu',
    'All Months': 'Kaikki kuukaudet',
    'All Years': 'Kaikki vuodet',
    'Thinking...': 'Ajattelee...',
    'Type a message...': 'Kirjoita viesti...',
    'Loading chat history...': 'Ladataan keskusteluhistoriaa...',
    'Chat thread not found': 'Keskusteluketjua ei löytynyt',
    'Failed to initialize chat': 'Keskustelun alustaminen epäonnistui',
    'No messages found in this chat':
      'Tästä keskustelusta ei löytynyt viestejä',
    'Failed to load chat history': 'Keskusteluhistorian lataaminen epäonnistui',
    'An unexpected error occurred': 'Tapahtui odottamaton virhe',
    'Something went wrong': 'Jokin meni pieleen',
    'No chat thread available': 'Keskusteluketjua ei löytynyt',
    'This activity entry or file does not have an associated chat thread yet.':
      'Tapahtumaan tai tiedostoon ei liity vielä viestiketjua.',
    Retry: 'Yritä uudelleen',
    Refresh: 'Päivitä',
    'Refreshing...': 'Päivitetään...',
    'Scroll to bottom': 'Vieritä alas',
    'View and manage your documents': 'Tarkastele ja hallitse dokumenttejasi',
    'Track and manage your tasks': 'Seuraa ja hallitse tehtäviäsi',
    'password-requirements':
      'Salasanan tulee olla vähintään 10 merkkiä pitkä ja sisältää vähintään yhden ison kirjaimen, yhden pienen kirjaimen ja yhden numeron.',
    'Latest entry': 'Viimeisin tapahtuma',
    'Latest file': 'Viimeisin tiedosto',
    'Latest task': 'Viimeisin tehtävä',
    'Latest description': 'Viimeisin kuvaus',
    'Latest instruction': 'Viimeisin ohje',
    'n-entries': 'tapahtumaa',
    'n-tasks': 'tehtävää',
    'n-descriptions': 'kuvausta',
    'n-instructions': 'ohjetta',
    'n-files': 'tiedostoa',
    '1-entry': 'tapahtuma',
    '1-task': 'tehtävä',
    '1-description': 'kuvaus',
    '1-instruction': 'ohje',
    '1-file': 'tiedosto',
    'Assistant is thinking...': 'Assistentti miettii...',
    'Waiting for entrepreneur...': 'Yrittäjän vuoro vastata...',
    'Waiting for accountant...': 'Kirjanpitäjän vuoro vastata...',
    Actions: 'Toiminnot',
    'Add Row': 'Lisää rivi',
    'No tasks available': 'Ei tehtäviä',
    'No descriptions available': 'Ei kuvauksia',
    'No instructions available': 'Ei ohjeita',
    Enter: 'Syötä',
    Task: 'Tehtävä',
    'Save Tasks': 'Tallenna Tehtävät',
    'Failed to load tasks data': 'Tehtävien tietojen lataaminen epäonnistui',
    'Tasks saved successfully': 'Tehtävien tallentaminen onnistui',
    'Failed to save tasks': 'Tehtävien tallentaminen epäonnistui',
    Description: 'Kuvaus',
    'Save Descriptions': 'Tallenna kuvaukset',
    'Failed to load descriptions data':
      'Kuvausten tietojen lataaminen epäonnistui',
    'Descriptions saved successfully': 'Kuvausten tallentaminen onnistui',
    'Failed to save descriptions': 'Kuvausten tallentaminen epäonnistui',
    Instruction: 'Ohje',
    'Save Instructions': 'Tallenna ohjeet',
    'Failed to load instructions data':
      'Ohjeiden tietojen lataaminen epäonnistui',
    'Instructions saved successfully': 'Ohjeiden tallentaminen onnistui',
    'Failed to save instructions': 'Ohjeiden tallentaminen epäonnistui',
    'Organisation Settings': 'Organisaation Asetukset',
    'Accountant Settings': 'Kirjanpitäjän Asetukset',
    'Accountant email': 'Kirjanpitäjän sähköposti',
    'Bank Statement Frequency': 'Tiliotteiden Lähetysajankohta',
    'Do not send bank statements': 'Älä lähetä tiliotteita',
    'Send bank statements daily': 'Lähetä tiliotteet päivittäin',
    'Send bank statements monthly': 'Lähetä tiliotteet kuukausittain',
    'Send all vouchers': 'Lähetä kaikki kuitit',
    'Accounting start date': 'Kirjanpidon aloituspäivä',
    'Netvisor Integration': 'Netvisor-integraatio',
    'Organization ID': 'Organisaation ID',
    'User ID': 'Käyttäjän ID',
    'User key': 'Käyttäjän avain',
    'Save Netvisor Settings': 'Tallenna Netvisor-asetukset',
    'Fennoa Integration': 'Fennoa-integraatio',
    Username: 'Käyttäjätunnus',
    'API key': 'API-avain',
    'Save Fennoa Settings': 'Tallenna Fennoa-asetukset',
    'Fortnox Integration': 'Fortnox-integraatio',
    'Fortnox integration is enabled': 'Fortnox-integraatio on käytössä',
    'Connect your Fortnox account to enable integration':
      'Yhdistä Fortnox-tilisi käyttääksesi integraatiota',
    'Connect to Fortnox': 'Yhdistä Fortnox-tili',
    'Organisation members': 'Organisaation jäsenet',
    Name: 'Nimi',
    'User identifier': 'Käyttäjätunnus',
    Rights: 'Oikeudet',
    Call: 'Soita',
    Add: 'Lisää',
    Today: 'Tänään',
    Yesterday: 'Eilen',
    'Unknown Date': 'Tuntematon päivämäärä',
    'days ago': 'päivää sitten',
    'Search entries...': 'Hae tapahtumia...',
    Filters: 'Suodattimet',
    'New chat': 'Uusi keskustelu',
    'No description': 'Ei kuvausta',
    'Search files...': 'Hae tiedostoista...',
    receipt: 'tosite',
    receipts: 'tositteet',
    'Export Group': 'Vie Ryhmä',
    'Export group': 'Vie ryhmä',
    'Export file': 'Vie tiedosto',
    'Export Selected': 'Vie Valitut',
    'Export selected': 'Vie valitut',
    'Export All': 'Vie Kaikki',
    'Export all': 'Vie kaikki',
    expense: 'Kulut',
    income: 'Tulot',
    'bank statement': 'Tiliote',
    document: 'Dokumentti',
    'no category': 'Ei kategoriaa',
    Showing: 'Näytetään',
    '1-result': 'hakutulos',
    'n-results': 'hakutulosta',
    'Export Options': 'Vientivalinnat',
    'Choose how you want to receive the file':
      'Valitse, miten haluat vastaanottaa tiedoston',
    'Download Zip': 'Lataa Zip',
    'Send by Email': 'Lähetä Sähköpostilla',
  },
};
